

















































import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
import type { PropType } from '@vue/composition-api';
import { computed, ref, defineComponent } from '@vue/composition-api';
import { ChatHelper } from '../helpers/chat.helper';
import type { ChatParticipant } from '../types/chat-participant';

export default defineComponent({
  props: {
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    recipients: {
      type: Array as PropType<SigningPageRecipient[]>,
      required: true,
    },
    recipientId: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const showParticipants = ref(false);

    const hasRecipients = computed((): boolean => props.recipients?.length > 0);

    const chatParticipants = computed(() =>
      ChatHelper.getChatParticipants(props.sender, props.recipients, props.recipientId)
    );

    const headerText = computed((): string => {
      if (!chatParticipants.value) {
        return '';
      }
      return `${chatParticipants.value
        .map((participant: ChatParticipant, index: number) => {
          const displayName = ChatHelper.getDisplayName(participant);
          return `${displayName}${ChatHelper.addPunctuationMark(
            index,
            chatParticipants.value.length
          )}`;
        })
        .join(' ')}`;
    });

    const closeParticipantList = () => {
      showParticipants.value = false;
    };

    const toggleParticpantList = () => {
      if (!hasRecipients.value) {
        return;
      }
      showParticipants.value = !showParticipants.value;
    };

    const handleClose = () => {
      emit('close');
    };

    return {
      getDisplayName: ChatHelper.getDisplayName,
      showParticipants,
      hasRecipients,
      chatParticipants,
      headerText,
      closeParticipantList,
      toggleParticpantList,
      handleClose,
    };
  },
});
